<template>
  <v-col cols="2" class="left-panel">
    <div class="step-item">
      <div class="step-circle" :class="{ active: currentStep === 1 }">1</div>
      <div class="step-text">Configuración del proyecto</div>
    </div>

    <div class="step-line"></div>

    <div class="step-item">
      <div class="step-circle" :class="{ active: currentStep === 2 }">2</div>
      <div class="step-text">Herramientas</div>
    </div>

    <div class="step-line"></div>

    <div class="step-item">
      <div class="step-circle" :class="{ active: currentStep === 3 }">3</div>
      <div class="step-text">Creación de vistas</div>
    </div>
  </v-col>
</template>

<script>
export default {
  name: "CmsProgress",
  computed: {
    currentStep() {
      return this.$store.state.cms_view;
    },
  },
  methods: {
    goToStep(step) {
      // Se recomienda usar una mutación para actualizar el estado
      this.$store.state.cms_view = step;
    },
  },
};
</script>

<style scoped>
.left-panel {
  display: flex;
  flex-direction: column;
  padding-top: 30px;
}

.step-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
  cursor: pointer; /* Indica que es clickable */
}

/* Se usa inline-flex para asegurar un círculo perfecto */
.step-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ccc;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  flex-shrink: 0;
  font-size: 14px;
  margin-right: 10px;
}

/* Se colorea el círculo activo según cms_view */
.step-circle.active {
  background-color: #1976d2; /* Ajusta el color activo según tu tema */
}

.step-text {
  font-weight: 500;
}

.step-line {
  width: 2px;
  background-color: #ccc;
  margin: 0 auto;
  flex-shrink: 0;
  height: 60px;
}
</style>
